/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTag_tag = {
    readonly serviceId: string | null;
    readonly x: number | null;
    readonly y: number | null;
    readonly " $fragmentRefs": FragmentRefs<"ItemTagTooltip_tag">;
    readonly " $refType": "ItemTag_tag";
};
export type ItemTag_tag$data = ItemTag_tag;
export type ItemTag_tag$key = {
    readonly " $data"?: ItemTag_tag$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTag_tag">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemTag_tag",
  "type": "TradePhotoTag",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "x",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "y",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemTagTooltip_tag",
      "args": null
    }
  ]
};
(node as any).hash = '7ca37fea62fd5a939560a472b5cd09e7';
export default node;
